module.exports = __webpack_public_path__ + "assets/img/52@3x.d9524b79.png";